import Campaign from "../../../views/Campaigns";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const Campaigns = [
  {
    menuName: MenuNames.CAMPAIGNS,
    path: "/campaigns",
    component: Campaign,
    exact: true,
  },
];

export default Campaigns;
